/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'

/* global WorldWind */

export default class EoxSentinel2Cloudless2018 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Sentinel-2 Cloudless (2018)",
            service: "https://tiles.maps.eox.at/wms",
            version: "1.3.0",
            layerNames: "s2cloudless-2018",
            styleNames: "" // (optional): {String} A comma separated list of the styles to include in this layer.</li>
        };
        super(cfg);

        // Make this layer opaque
        this.opacity = 1.0;

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "Sentinel-2 cloudless by EOX IT Services GmbH (Contains modified Copernicus Sentinel data 2017 & 2018)",
                WorldWind.Color.LIGHT_GRAY);
        }
    }
}
